/** JSON mit sortierten Schlüsseln; PostgreSQL (jsonb) liefert Schlüssel in eigener Reihenfolge zurück. */
function canonical(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonical).join(",")}]`;
  if (value && typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, v]) => v !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonical(v)}`).join(",")}}`;
  }
  return JSON.stringify(value ?? null);
}

/** Gleicher Inhalt unabhängig von der Reihenfolge der Schlüssel. */
export function sameContent(a: unknown, b: unknown): boolean {
  return canonical(a) === canonical(b);
}
